import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 版本管理-查询-tr
export const getRevenueVersionPage = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastVersion/query',
        method: 'post',
        data
    });
};
// 版本管理-根据预测月份查询版本信息-tr
export const getRevenueVersionByMonth = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastVersion/listVersionByMonth',
        method: 'post',
        data
    });
};
// 版本管理-新增-tr
export const revenueVersionAdd = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastVersion/add',
        method: 'post',
        data
    });
};
// 版本管理-修改-tr
export const revenueVersionUpdate = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastVersion/update',
        method: 'post',
        data
    });
};
// 版本管理-审核-tr
export const revenueVersionSubmit = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastVersion/submit',
        method: 'post',
        data
    });
};
